<template>
  <div>
    <div class="radios">
      <RadioGroup
        v-model="checkerSource"
        @on-change="checkerSourceChange"
      >
        <Radio border label="user">个人查档</Radio>
        <Radio border label="company">单位查档</Radio>
      </RadioGroup>
    </div>
    <validate-form
      ref="validateForm"
      :formItems="formItems"
      labelPosition="right"
      :labelWidth="130"
    />
    <FileUpload
      class="fileUpload"
      v-for="u in uploadList"
      :key="`${archiveQueryType.value}${u.type}`"
      :prompt="u.title"
      :remarks="u.remarks"
      :files.sync="u.files"
    />
    <Alert
      class="alert"
      type="warning"
      v-for="(f, index) in $config.registerTips"
      :key="index"
    >{{ f }}</Alert>
    <div class="btn">
      <Button
        :loading="loading"
        type="primary"
        @click="handleSubmit"
      >提交</Button>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import ValidateForm from '@components/validate-form'
import { checkerTypeList, formatDate  } from '@libs/util'
import { PostSubscribe, GetUserInfo } from '@api'
import FileUpload from '@components/upload'
export default {
  name: 'reservation',
  components: { ValidateForm, FileUpload },
  props: {
    formItems: {
      type: Array,
      default: () => []
    },
    otherParams: {
      type: Object,
      default: () => ({})
    },
    unitType: {
      type: String
    }
  },
  data () {
    return {
      checkerSource: '',
      loading: false
    }
  },
  computed: {
    archiveQueryType () {
      return this.formItems.find(f => f.key === 'ArchiveQueryType')
    },
    uploadList () {
      //先写死
      return checkerTypeList[0].uploadList
      const value = this.archiveQueryType ? this.archiveQueryType.value : false
      const checkType = checkerTypeList.find(f => f.value === value)
      if (value && checkType) {
        return checkType.uploadList
      }
      return checkerTypeList[0].uploadList
    },
    minHeight () {
      return { 'min-height': `${this.$store.state.init.offsetHeight - 251}px` }
    }
  },
  watch: {
    checkerSource () {
      this.checkerSourceChange()
    }
  },
  mounted () {
    this.checkerSource = this.unitType
  },
  methods: {
    checkerSourceChange () {
      const companyName = this.formItems.find(f => f.key === 'CompanyName')
      const queryType = this.formItems.find(f => f.key === 'ArchiveQueryType')
      switch (this.checkerSource) {
        case 'user':
          this.$set(companyName, 'hide', true)
          this.$set(companyName, 'value', '')
          this.$set(queryType, 'label', '查档人类型')
          this.$set(queryType, 'width', '100%')
          break
        case 'company':
          this.$set(companyName, 'hide', false)
          this.$set(queryType, 'label', '查档单位类型')
          this.$set(queryType, 'width', '50%')
          break
      }
    },
    async handleSubmit () {
      const item = await this.$refs['validateForm'].validate()
      if (item) {
        this.loading = true
        try {
          item.SubscribeType = this.checkerSource
          item.UploadFiles = this.uploadList.map(m => {
            if (!m.files.length) {
              const msg = `${m.title} 未上传照片`
              this.$Message.warning(msg)
              throw msg
            }
            return {
              FileType: m.type,
              FileContent: m.title,
              FileName: m.files.map(f => f.response.split('/').pop())
            }
          })
          item.FileIDS = item.QueryContent.map(m => m.SID).join(',')
          item.QueryContent = item.QueryContent.map(m => m.FILE_TITLE).join('|')
          Object.assign(item, this.otherParams)
          const { data: { Code, Msg } } = await PostSubscribe(item)
          if (!Code) {
            const onOk = () => {
              this.$router.push({
                name: 'record',
                params: { reload: true }
              })
            }
            this.$Modal.success({
              title: '提示',
              content: '您的查档信息登记成功。工作日24小时内审核，审核结果自动发送，请留意邮箱。（法定节假日不受理）',
              onOk
            })
          } else {
            this.$Message.error(Msg || '提交失败')
          }
        } catch (e) {
          console.error(e)
        }
        this.loading = false
      }
    },
    handleBack () {
      this.$router.push({ name: 'search' })
    }
  }
}
</script>

<style lang="scss" scoped>
.radios {
  text-align: center;
  margin: 12px 0;
  .ivu-radio-wrapper {
    margin: 0 16px;
  }
}
.fileUpload {
  margin-left: 50px;
}
.btn {
  text-align: center;
  margin-top: 16px;
  .ivu-btn {
    margin: 0 32px;
  }
}
.alert {
  text-align: center;
  font-size: 16px;
  padding: 8px 16px;
}
</style>
